import type React from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from '@fluentui/react-components';
import { IncidentState } from 'types';

interface StateBadgeProps {
  state: IncidentState;
  size?: 'small' | 'medium' | 'large' | 'extra-large';
}

const stateAppearanceMap: Record<IncidentState, 'filled' | 'ghost' | 'outline' | 'tint'> = {
  [IncidentState.New]: 'filled',
  [IncidentState.Active]: 'filled',
  [IncidentState.Closed]: 'outline',
};

const stateColorMap: Record<IncidentState, 'brand' | 'danger' | 'important' | 'informative' | 'severe' | 'subtle' | 'success' | 'warning'> = {
  [IncidentState.New]: 'informative',
  [IncidentState.Active]: 'severe',
  [IncidentState.Closed]: 'subtle',
};

export const StateBadge: React.FC<StateBadgeProps> = ({ state, size = 'medium' }) => {
  const { t } = useTranslation();

  return (
    <Badge
      appearance={stateAppearanceMap[state]}
      color={stateColorMap[state]}
      size={size}
    >
      {t(`statusPanel.state.${state}`)}
    </Badge>
  );
};
